import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs';
import { VideoPlayerComponent } from '../../../shared/component/video-player/video-player.component';

@Component({
  selector: 'black-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css'],
  imports: [VideoPlayerComponent],
  standalone: true,
  host: {
    class: 'w-full h-full block',
  },
})
export class VideoComponent implements OnInit {
  private route = inject(ActivatedRoute);

  resourceId = '';

  ngOnInit(): void {
    this.route.params
      .pipe(map((param) => param['id']))
      .subscribe((id) => {
        if (!id) return;
        this.resourceId = decodeURIComponent(id);
      });
  }
}
